(() => {
  function start(root) {
    if (root.dataset.couponReady) return;
    root.dataset.couponReady = 'true';
    const cards = [...root.querySelectorAll('[data-coupon-item]')];
    const category = root.querySelector('[data-coupon-category]');
    const brand = root.querySelector('[data-coupon-brand]');
    function refresh() {
      let registry;
      try { registry = JSON.parse(document.getElementById('bizedeals-partnerboost-registry')?.dataset.offers || '{}'); } catch { registry = {}; }
      const active = cards.filter(card => {
        if (typeof eligibleOffer !== 'function') return false;
        const offer = eligibleOffer(registry, { asin: card.dataset.asin, path: card.dataset.path });
        return offer && offer.test !== true && offer.type === 'code' && card.querySelector('[data-snapshot]');
      });
      for (const [select, key] of [[category,'category'],[brand,'brand']]) {
        if (!select) continue;
        const values = [...new Set(active.map(c => c.dataset[key]).filter(Boolean))].sort();
        const signature = JSON.stringify(values);
        if (select.dataset.values !== signature) {
          const selected = select.value;
          while (select.options.length > 1) select.remove(1);
          values.forEach(value => select.add(new Option(value,value)));
          select.value = values.includes(selected) ? selected : '';
          select.dataset.values = signature;
        }
      }
      let visible = 0;
      cards.forEach(card => {
        const show = active.includes(card) && (!category?.value || card.dataset.category === category.value) && (!brand?.value || card.dataset.brand === brand.value);
        card.hidden = !show;
        if (show) visible++;
      });
      if (root.dataset.mode === 'rail') root.hidden = active.length === 0;
      const filters = root.querySelector('[data-coupon-filters]');
      if (filters) filters.hidden = active.length === 0;
      const empty = root.querySelector('[data-coupon-empty]');
      if (empty) empty.hidden = active.length !== 0;
      const noMatch = root.querySelector('[data-coupon-no-match]');
      if (noMatch) noMatch.hidden = active.length === 0 || visible > 0;
    }
    root.addEventListener('change',refresh);
    document.addEventListener('visibilitychange',refresh);
    refresh();
    const timer = setInterval(() => { if (!root.isConnected) clearInterval(timer); else refresh(); },1000);
  }
  document.querySelectorAll('[data-coupon-section]').forEach(start);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-coupon-section]').forEach(start));
})();